<template>
    <div class="pa-0">
        <VRow v-for="(item, index) in items" :key="index" class="item-row">
            <VCol cols="11" class="py-0">
                <slot :item="item" :index="index" />
            </VCol>
            <VCol v-if="isRemoveVisible" cols="1" class="pl-0">
                <SrButton class="remove-button" icon :disabled="disabled" @click="$emit('removeItem', index)">
                    <SrIcon icon="Trash" size="xs" :disabled="disabled" />
                </SrButton>
            </VCol>
        </VRow>
        <VRow v-if="isAddVisible" justify="end" class="add-row">
            <VCol class="d-flex justify-end pt-0" cols="11">
                <SrButton class="add-button" type="secondary" elevation="0" :disabled="disabled" @click="$emit('addItem')">
                    Add new {{ itemName }}
                </SrButton>
            </VCol>
            <VCol cols="1" />
        </VRow>
    </div>
</template>

<script>
import { SrButton } from '../SrButton';
import { SrIcon } from '../SrIcon';

export default {
    components: { SrButton, SrIcon },
    props: {
        items: {
            type: Array,
            required: true,
        },
        itemName: {
            type: String,
            default: 'Item',
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        minItems: {
            type: Number,
            default: 0,
        },
        maxItems: {
            type: Number,
            default: Number.MAX_SAFE_INTEGER,
        },
    },
    computed: {
        isAddVisible() {
            return this.items.length < this.maxItems;
        },
        isRemoveVisible() {
            return this.items.length > this.minItems;
        },
    },
};
</script>
